import { ProcurementStatusEnum } from "./enum/StatusProcurement";
import { getTranslateByKey } from "./utils";

const MAP_PROCUREMENT_STATUS_TRANSLATE_KEY: Record<number, string> = {
	[ProcurementStatusEnum.Assigned]: "procurementstatus.assigned",
	[ProcurementStatusEnum.Transit]: "procurementstatus.transit",
	[ProcurementStatusEnum.Delivered]: "procurementstatus.delivered",
	[ProcurementStatusEnum.Invoiced]: "procurementstatus.invoiced",
	[ProcurementStatusEnum.Paid]: "procurementstatus.paid",
	[ProcurementStatusEnum.Open]: "procurementstatus.open",
	[ProcurementStatusEnum.Manual]: "procurementstatus.manual",
	[ProcurementStatusEnum.Cancelled]: "procurementstatus.canceled",
	[ProcurementStatusEnum.Closed]: "procurementstatus.closed",
	[ProcurementStatusEnum.Received]: "procurementstatus.received",
	[ProcurementStatusEnum.PreQuote]: "procurementstatus.preQuote",
	[ProcurementStatusEnum.CancelProcess]: "procurementstatus.cancelProcess",
	[ProcurementStatusEnum.ReturnProcess]: "procurementstatus.returnProcess",
	[ProcurementStatusEnum.Returned]: "procurementstatus.returned",
	[ProcurementStatusEnum.Transferred]: "procurementstatus.transferred",
	[ProcurementStatusEnum.ReturnApprovalProcess]: "procurementstatus.returnApprovalProcess",
	[ProcurementStatusEnum.WaitingRelease]: "procurementstatus.awaitingRelease",
	[ProcurementStatusEnum.AwaitingPayment]: "procurementstatus.awaitingPayment",
	[ProcurementStatusEnum.AwaitingApproval]: "procurementstatus.awaitingApproval",
};

export function getProcurementStatusName(id: number | null): string {
	const translateKey = id ? MAP_PROCUREMENT_STATUS_TRANSLATE_KEY[id] : "";

	return translateKey ? getTranslateByKey(translateKey) : "";
}
